module.exports = __webpack_public_path__ + "static/media/profilePic_Imtiyaz.e8afefa8.jpg";